<template>
  <div>
    <RouterLink to="/rules" class="footer_link">{{ $t('Правила Программы «Карта Леста от Альфа Банка»') }}<LinkIcon /></RouterLink>
    <p>{{ $t('ЗАО «Альфа-Банк». Ген. лиц. НБРБ № 22 от 08.02.2024г.') }}</p>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import LinkIcon from '@/common/components/Decoration/LinkIcon'

@Component({
  components: {
    LinkIcon
  }
})
class LicenseRu extends Vue {
  @Prop({ type: Number }) year
}

export default LicenseRu
</script>
